import {
  Box,
  CloseButton,
  Divider,
  Group,
  Paper,
  Text,
  ThemeIcon,
} from "@mantine/core";
import { useFlowStore } from "../../../../../../stores/WorkflowStore";
import { useEffect, useMemo, useRef } from "react";
import { getNodeDetails } from "../flowSettings";
import NodePanelAdvanced from "./NodePanelAdvanced";
import NodePanelMain from "./NodePanelMain";
import PanelClosedContent from "./PanelClosedContent";
import { useReactFlow } from "reactflow";

const NodeActionPanel = ({ inSheet }) => {
  const nodes = useFlowStore((s) => s.nodes);
  const selectedNode = useFlowStore((s) => s.selectedNode);
  const setSelectedNode = useFlowStore((s) => s.setSelectedNode);
  const initialId = useFlowStore((s) => s.initialId);
  const reactFlow = useReactFlow();

  const actualNode = useMemo(() => {
    return nodes.find((x) => x.id === selectedNode?.id);
  }, [selectedNode, nodes]);

  const nodeDetail = useMemo(
    () => getNodeDetails(actualNode?.data.actionType),
    [actualNode]
  );

  const handleClose = () => {
    let n = { ...selectedNode };
    setSelectedNode(null);

    setTimeout(() => {
      reactFlow?.setCenter(
        n.x + 128,
        n.y + (n?.data?.source === initialId ? window.innerWidth / 7 : 96),
        {
          duration: 200,
          zoom: 1,
        }
      );
    }, 300);
  };

  useEffect(() => {
    if (selectedNode) {
      setTimeout(() => {
        reactFlow?.setCenter(
          selectedNode.x + 128,
          selectedNode.y + (selectedNode?.data?.source === initialId ? window.innerWidth / 7 : 0),
          {
            duration: 200,
            zoom: 1,
          }
        );
      }, 300);
    }
  }, [selectedNode, initialId]);

  useEffect(() => {
    let n = nodes.find((x) => x.id === selectedNode?.id);
    if (!n) {
      setSelectedNode(null);
    }
  }, [nodes, selectedNode, setSelectedNode]);

  const paper = useRef(null);

  useEffect(() => {
    if (paper?.current) {
      if (selectedNode?.toAdvanced) {
        const offsetTop = document.getElementById(
          "panel-advaced-settings"
        ).offsetTop;

        setTimeout(() => {
          if (paper?.current) paper.current.scrollTop = offsetTop;
        }, 200);
      } else {
        setTimeout(() => {
          if (paper?.current) paper.current.scrollTop = 0;
        }, 200);
      }
    }
  }, [selectedNode?.toAdvanced, paper]);

  if (nodes.length === 2) {
    return;
  }

  return (
    <Paper
      mr={actualNode ? 0 : "calc(-90% + 128px)"}
      w={"90%"}
      style={{
        transition: "all ease .3s",
      }}
      className={"workflow-panel " + (actualNode ? "" : "closed")}
      radius={16}
      withBorder
      mb={inSheet ? 0 :12}
      pos={"relative"}
      bg={"#fff"}
    >
      {selectedNode ? (
        <>
          <CloseButton
            onClick={handleClose}
            pos={"absolute"}
            top={0}
            left={-42}
            size={"lg"}
          />

          <Box
            h={"100%"}
            p={"sm"}
            style={{ overflow: "auto", scrollBehavior: "smooth" }}
            ref={paper}
          >
            <Group w={"100%"}>
              <ThemeIcon variant="light" color={nodeDetail?.color} size={"lg"}>
                {nodeDetail?.icon}
              </ThemeIcon>
              <Text fz={"lg"}>{nodeDetail?.label}</Text>
              <Text ml="auto" opacity={0.35}>
                #{actualNode?.id}
              </Text>
            </Group>
            <Divider my={"sm"} />
            <NodePanelMain />
            <NodePanelAdvanced
              node={actualNode}
              key={actualNode?.id}
              isSource={actualNode?.data?.source === initialId}
            />
          </Box>
        </>
      ) : (
        <PanelClosedContent />
      )}
    </Paper>
  );
};

export default NodeActionPanel;
